import React from "react";
import "../../CSS/Industries.css";

function Startups() {
    return (
        <>
           
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">

                    <div className="industry-detail-hero-content">



                        <h1>
                            Solutions for Startups & Small Businesses
                        </h1>

                        <p style={{ color: '#FF7D37' }}>
                            Turn your business idea into a practical digital
                            solution with websites, applications, software,
                            databases, and technology consulting.
                        </p>

                    </div>

                </div>
            </section>


            <section className="industry-detail-section">

                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">



                            <h2>
                                Build, Launch & Grow With Technology
                            </h2>

                            <p>
                                Startups and small businesses need technology
                                that is practical, scalable, and aligned with
                                their budget and business goals.
                            </p>

                            <p>
                                We help businesses build websites, mobile apps,
                                web applications, custom software, databases,
                                and other digital solutions.
                            </p>

                        </div>

                        <div className="col-lg-6">

                            <img
                                src="/images/home/startups.png"
                                alt="Startup Technology Solutions"
                                className="industry-detail-image"
                            />

                        </div>

                    </div>

                </div>

            </section>


            <section className="industry-features">

                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for<br /> Startups & Small Businesses</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-lightbulb"></i>
                            <h3>Business Ideas</h3>
                            <p>Technology planning and development for new digital business ideas.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-window"></i>
                            <h3>Web Applications</h3>
                            <p>Custom web applications designed around your business requirements.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-phone"></i>
                            <h3>Mobile Applications</h3>
                            <p>Mobile solutions for customers, employees, and business operations.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-rocket-takeoff"></i>
                            <h3>Business Growth</h3>
                            <p>Digital solutions that can grow as your business grows.</p>
                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default Startups;